import { render, staticRenderFns } from "./ListasSeparacaoAutocomplete.vue?vue&type=template&id=64a9d48e"
import script from "./ListasSeparacaoAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./ListasSeparacaoAutocomplete.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports